module.exports = "/images/vendor/flag-icon-css/flags/4x3/fi.svg?2649533e1d44a2ef75d5679ef6839b9e";